import React, { useEffect, useState } from 'react'
import { PharmacyDrug, Reports } from 'services/api'
import dashboardWidgets from './widgets'
import { WidgetInterface } from 'interfaces'
import { StatsWidget } from 'components/public'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { ColorEnum, SupplyLastUpdate } from 'enum'
import { Grid } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

const AllWidgets: React.FC = () => {
  const { getWidgetInfo } = new Reports()
  const { getLastUpdate } = new PharmacyDrug()
  const { t } = useTranslation()
  const [widgetData, setWidgetData] = useState<WidgetInterface[]>()

  useEffect(() => {
    async function getWidgetData() {
      const result = await getWidgetInfo()
      setWidgetData(result)
    }
    getWidgetData()

    // This will be usded to check if it's more 5 days that user didn't
    // update their supply list items, so we show 'em an alarm.
    async function getLastUpdateData() {
      const result = await getLastUpdate()
      localStorage.setItem(SupplyLastUpdate, result)
    }
    getLastUpdateData()
  }, [])

  return (
    <Grid item xs={12} container spacing={3} style={{ marginRight: 0 }}>
      {widgetData &&
        widgetData?.length > 0 &&
        React.Children.toArray(
          dashboardWidgets.map((wData: WidgetInterface, index: number) => {
            let w = widgetData.filter((i) => i.name === wData.name)[0]
            w = {
              // ...w,
              ...wData,
              // title: wData.title,
              title: t(`widget.${wData.name}`),
              value: w?.value ?? '',
            }
            return (
              <Grid
                item
                xs={12}
                sm={6}
                md={'auto'}
                xl={'auto'}
                style={index !== widgetData.length - 1 ? { flexGrow: 1 } : {}}
              >
                <div>
                  <StatsWidget
                    title={w.title ?? ''}
                    value={w.value ?? 0}
                    icon={
                      <FontAwesomeIcon
                        icon={w.icon ?? faInfoCircle}
                        size="4x"
                      />
                    }
                    backColor={w.backColor ?? ColorEnum.White}
                    color={w.color ?? ColorEnum.Black}
                    titleFontSize={w.titleFontSize}
                    to={w.to ?? undefined}
                    description={w.description ?? ''}
                  />
                </div>
              </Grid>
            )
          }),
        )}
    </Grid>
  )
}

export default AllWidgets
